import AddInverter from "./EditInverter";

export default AddInverter;
